import script from "./ResourceErrorState.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceErrorState.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceErrorState.vue?vue&type=style&index=0&id=056c6e52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056c6e52"]])

export default __exports__